import React from 'react';
import { avatarPath, profilePath } from '../../../lib/platformUrls';
import { avatars } from '../../../settings';
import { Avatar, AvatarSize } from './Avatar';

interface UserAvatarProps {
    size?: AvatarSize;
    isLinked?: boolean;
    isOnline?: boolean;
    userId: string;
    userName?: string;
}
export function UserAvatar({
    size = 'medium',
    isLinked = false,
    isOnline = false,
    userId,
    userName,
}: UserAvatarProps) {
    const avatar = (
        <Avatar
            size={size}
            avatarUrl={avatarPath(userId, avatars.sizes[size].avatarSize)}
            online={isOnline}
            userName={userName}
        />
    );

    if (isLinked) {
        return (
            <a href={profilePath(userId)} data-testid="UserAvatar">
                {avatar}
            </a>
        );
    }

    return avatar;
}
